<template>
	<div class="head-top">
		<div class="headbg">
			<div>
				<el-image class="headlogo" :src="require('../../../assets/default/logo.png')" @click="gotoGW">
				</el-image>
			</div>

			<!-- <div style="width: 40%; text-align: center;   "> -->
			<div style="text-align: center;   ">
				<div class="headitem">
					<div class="row">
						<div class="textFont mar20 webmag10 hometoptext" style="" @click="gotoGW">
							{{$t('headView.headView_lbl0')}}
						</div>
						<div class="textFont mar20 webmag10 hometoptext" style="" @click="toHome">
							{{$t('headView.headView_lbl1')}}
						</div>
					</div>
					<div class="headright">
						<div v-if="userid==''" style="width: 80px; height: 30px; background-color:  #FF9C00; "
							@click="login">
							<div style="margin-top: 3px; font-size: 13px;" class="textFont">
								{{$t('headView.headView_lbl3')}}
							</div>
						</div>

						<div v-else style="width: 80px; height: 30px; background-color:  #FF9C00; ">
							<div style="margin-top: 3px; font-size: 13px;" class="textFont">
								<!-- {{$t('headView.headView_lbl2')}} -->
								<el-dropdown @command="loginhandleCommand">

									<div style="color: #FFFFFF; margin-top: 3px; font-size: 13px;" class="textFont">
										{{$t('headView.headView_lbl2')}}
									</div>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="toMypage" @click="toMypage">
											{{$t('headView.headView_lbl9')}}
										</el-dropdown-item>
										<el-dropdown-item command="out">{{$t('headView.headView_lbl10')}}
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<!-- 多语言切换 -->
						<div style="width: 80px; height: 30px; background-color:#333333 ; ">

							<el-dropdown @command="handleCommand">

								<div style="color: #FFFFFF; margin-top: 3px; font-size: 13px;" class="textFont">
									{{$t('headView.headView_lbl4')}}
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="ja">{{$t('headView.headView_lbl5')}}</el-dropdown-item>
									<el-dropdown-item command="zh">{{$t('headView.headView_lbl6')}}</el-dropdown-item>
									<el-dropdown-item command="en">{{$t('headView.headView_lbl14')}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</div>
				<div class="headtext">
					<div style="" class="textFont headtexttel">
						<span style="" class="">{{$t('headView.headView_lbl7')}}</span>
					</div>

					<div style="" class="headtexttel1">
						{{$t('headView.headView_lbl8')}}
					</div>
				</div>

			</div>
		</div>


		<el-dialog ref="login" class="login" :visible.sync="dialogLoginVisible" @close="closeLogin">
			<login ref="loginView" @resetPassword='resetPassword' @register="register" @loginSubmit="loginSubmit">
			</login>
		</el-dialog>


		<el-dialog ref="reset" class="reset" :visible.sync="dialogResetVisible" @close="closeReset"
			:close-on-click-modal='false'>
			<reset ref="resetView" @submitReset='resetSubmit'></reset>
		</el-dialog>

		<el-dialog ref="Register" class="register" :visible.sync="dialogRegisterVisible" @close="closeRegister"
			:close-on-click-modal='false'>
			<register ref="registerView" @toLogin='login' @registerSubmit='registerSubmit'></register>
		</el-dialog>
	</div>

</template>

<script>
	import Login from '../../../views/Login.vue'
	import reset from '../../../views/ResetPasswordView.vue'

	import register from '../../../views/Register.vue'
	export default {
		inject: ['reload'], //在子组件中通过inject调用
		components: {
			Login,
			reset,
			register

		},
		data() {

			return {
				userid: '',
				dialogLoginVisible: false,
				dialogResetVisible: false,
				dialogRegisterVisible: false,
				// userid: '',
				useridl: '',
				paddwordl: '',
				lang: 0

			}
		},
		created() {
			
			if (this.$i18n.locale == 'ja') {
				this.lang = 0
			}
			else if (this.$i18n.locale == 'zh') {
				this.lang = 1
			}
			else if (this.$i18n.locale == 'en') {
				this.lang = 2
			}
			if (sessionStorage.getItem('log_email') == '' || sessionStorage.getItem('log_email') == null) {
				if (document.cookie.length > 0) {
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "userName") {
							this.useridl = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.passwordl = arr2[1];
						}
					}
					this.$api.post(this.$config.login, {
							// 'YHSEQNUM': localStorage.getItem('YHSEQNUM')
							'sCOMID': '037',
							//'sCOMID': '901',
							'sEMAIL': this.useridl,
							'sPassword': this.passwordl,
							'sLNGCT': this.lang
						},
						// 请求成功
						success => {
							console.log(success)
							if (success.KKDT[0].code == 200) {
								sessionStorage.setItem('log_ditdt', success.KKDT[0].BITDT);
								sessionStorage.setItem('log_comid', success.KKDT[0].COMID);
								sessionStorage.setItem('log_delfg', success.KKDT[0].DELFG);
								sessionStorage.setItem('log_email', success.KKDT[0].EMAIL);
								sessionStorage.setItem('log_famkn', success.KKDT[0].FAMKN);
								sessionStorage.setItem('log_famnm', success.KKDT[0].FAMNM);
								sessionStorage.setItem('log_givkn', success.KKDT[0].GIVKN);
								sessionStorage.setItem('log_givnm', success.KKDT[0].GIVNM);
								sessionStorage.setItem('log_mstid', success.KKDT[0].MSTID);
								sessionStorage.setItem('log_paswd', success.KKDT[0].PASWD);
								sessionStorage.setItem('log_regdt', success.KKDT[0].REGDT);
								sessionStorage.setItem('log_sexct', success.KKDT[0].SEXCT);
								sessionStorage.setItem('log_kkdtcount', success.KKDTCOUNT);


								this.userid = sessionStorage.getItem("log_email")
								console.log(this.userid)
								this.reload();
							}
						},
						// 请求失败
						error => {
							this.$message({
								message: this.login.login_16, //请求失败
								type: 'error'
							});
						}
					)
				}
			} else {
				this.userid = sessionStorage.getItem("log_email")
			}
		},
		methods: {
			closeLogin() {
				this.dialogLoginVisible = false
				this.$refs.loginView.toRefresh()
				this.$refs.loginView.checked = false
			},

			handleCommand(Command) {
				localStorage.setItem('locale', Command)
				this.$i18n.locale = Command
				this.reload();
			},
			login() {

				this.dialogLoginVisible = true;
				this.dialogResetVisible = false;
				this.dialogRegisterVisible = false;
			},

			resetPassword() {

				this.dialogLoginVisible = false;
				this.dialogRegisterVisible = false;
				this.dialogResetVisible = true;

			},

			register() {
				this.dialogLoginVisible = false;
				this.dialogResetVisible = false;
				this.dialogRegisterVisible = true;
			},

			loginSubmit() {

				this.dialogLoginVisible = false;

			},

			resetSubmit() {

				this.dialogResetVisible = false;
			},

			registerSubmit() {

				this.dialogRegisterVisible = false;
			},

			loginhandleCommand(Command) {
				if (Command == 'toMypage') {
					this.$router.push('/userinfo')
				}
				if (Command == 'out') {
					this.$confirm(this.$t('headView.headView_lbl11'), this.$t('headView.headView_lbl10'), {
						confirmButtonText: this.$t('headView.headView_lbl12'),
						cancelButtonText: this.$t('headView.headView_lbl13'),
						customClass:'loginshowcass'
					}).then(() => {
						sessionStorage.clear();
						this.$router.push('/')
						this.userid = ''
						this.setCookie("", "", -1)
					}).catch(() => {
					});
				}
			},

			setCookie(c_name, c_pwd, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			closeReset() {

				this.dialogResetVisible = false;
				this.$refs.resetView.$emit("closeReset")

				this.$refs.resetView.toRefresh()
			},

			closeRegister() {

				this.dialogRegisterVisible = false;
				this.$refs.registerView.$emit("closeRegister")

				this.$refs.registerView.toRefresh()
				this.$refs.registerView.check = false
			},

			gotoGW() {
				window.open('https://mrhiro-jdm.com/')
			},

			toHome() {
				sessionStorage.setItem("orderForm", "")
				if (this.$route.name != "Calendar") {
					this.$router.push('/')
				}

			},

			toMypage() {
				this.$router.push('/userinfo')
			}



		}

	}
</script>

<style scoped>
	.textFont {

		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;

	}

	.mar20 {
		margin-right: 20px;
	}

	@media (min-width: 1200px) {
		.app {
			background-color: aliceblue;
		}
	}

	/deep/ .login .el-dialog__body {

		background-color: #FE9C2C;
	}

	/deep/ .login .el-dialog__header {
		background-color: #FE9C2C;
	}

	/deep/ .login .el-icon-close:before {
		font-size: 20px;
		color: #000000;
	}

	/deep/ .reset .el-icon-close:before {
		font-size: 20px;
		color: #000000;
	}

	/deep/ .register .el-icon-close:before {
		font-size: 20px;
		color: #000000;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		font-weight: bold;
	}

	@media only screen and (min-width:680px) {
		.head-top {

			width: 100%;
			/* height: 100px; */
			border-bottom: 1px solid gray;
			display: flex;
			flex-direction: row;
			justify-content: space-between;

		}

		.headbg {
			width: 80%;
			display: flex;
			justify-content: space-between;
			margin: auto;
		}

		.headlogo {
			width: 280px;
			height: 70px;
			cursor: pointer;
		}

		.headitem {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin: auto;
		}

		.headright {
			font-weight: bold;
			display: flex;
			flex-direction: row;
			cursor: pointer;
		}

		.webmag10 {
			margin-top: 10px;
		}

		.headtexttel {
			font-size: 30px;
			font-weight: 700;
			margin: auto;
			text-align: right;
		}

		.headtexttel1 {
			margin: auto;
			text-align: right;
			font-size: 10px;
		}

		/deep/ .el-dialog {
			width: 40%;
		}

		/deep/ .register .el-dialog__body {
			padding-left: 34px;
		}

		/deep/ .reset .el-dialog__body {
			padding-left: 34px;
		}

		.hometoptext {
			font-weight: bold;
			font-size: 13px;
			cursor: pointer;
		}

	}

	@media only screen and (max-width:680px) {
		.head-top {

			width: 100%;
			/* height: 100px; */
			border-bottom: 1px solid gray;
			display: flex;
			flex-direction: row;
			justify-content: space-between;

		}

		.headbg {
			width: 100%;
			/* display: flex;
			justify-content: space-between; */
			margin: auto;
			padding: 0 4%;
			box-sizing: border-box;
		}

		.headlogo {
			width: 140px;
			height: 35px;
			cursor: pointer;
		}

		.headitem {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin: auto;
		}

		.headright {
			font-weight: bold;
			display: flex;
			flex-direction: row;
			cursor: pointer;
		}

		.headtext {
			/* display: flex;
			flex-direction: row;
			justify-content: space-between; */
			text-align:right
		}

		.headtexttel {
			font-size: 20px;
			font-weight: 700;
			/* margin:  auto; */
		}

		.headtexttel1 {
			margin: auto 0;
			font-size: 10px;
		}

		/deep/ .el-dialog {
			width: 86%;
		}

		.hometoptext {
			font-weight: bold;
			font-size: 10px;
			cursor: pointer;
		}

	}
	.row {
		display: flex;
		flex-direction: row;
	}
	@media only screen and (min-width:680px) and (max-width:1200px){
		
		/deep/ .el-dialog {
			width:70%;
		}
	}
</style>
